"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _withLocation = require("with-location");
var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));
var _usefulState = require("useful-state");
var _core = require("@material-ui/core");
var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));
var Utils = _interopRequireWildcard(require("../../Utils"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Offcanvas = (0, _withLocation.withLocation)(function (_ref) {
  var logo = _ref.logo,
    children = _ref.children,
    menuRenderer = _ref.menuRenderer,
    location = _ref.location;
  var _useToggle = (0, _usefulState.useToggle)(),
    state = _useToggle.state,
    toggle = _useToggle.toggle,
    close = _useToggle.close,
    open = _useToggle.open;
  var ref = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (!ref.current) {
      ref.current = true;
    } else {
      close();
    }
  }, [location.pathname]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, menuRenderer ? menuRenderer(toggle, state) : /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    size: "small",
    "aria-label": "Open menu",
    id: "menu-button",
    "aria-controls": "menu",
    "aria-expanded": state,
    onClick: open,
    color: "inherit"
  }, /*#__PURE__*/_react["default"].createElement(_Menu["default"], null)), /*#__PURE__*/_react["default"].createElement(_Drawer["default"], {
    onClose: close,
    variant: "temporary",
    anchor: "right",
    open: state,
    PaperProps: {
      style: {
        width: 320
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(Utils.Viewport, {
    style: {
      backgroundColor: '#FFF',
      overflow: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    p: 1
  }, /*#__PURE__*/_react["default"].createElement(_Toolbar["default"], {
    disableGutters: true,
    style: {
      justifyContent: 'space-between'
    }
  }, logo, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    "aria-label": "Close menu",
    onClick: close
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))), children))));
});
Offcanvas.defaultProps = {
  logo: null,
  children: null,
  menuRenderer: undefined
};
Offcanvas.propTypes = {
  logo: _propTypes["default"].node,
  children: _propTypes["default"].node,
  menuRenderer: _propTypes["default"].func
};
var _default = Offcanvas;
exports["default"] = _default;